import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) =>
	({
		featurePoints: {
			[theme.breakpoints.up("lg")]: {
				height: "100%",
			},
		},
		screenShot: {
			[theme.breakpoints.up("lg")]: {
				width: 400,
			},
			[theme.breakpoints.down("lg")]: {
				width: 300,
			},
		},
		subtitle: {
			fontWeight: "bold", fontSize: "larger"
		},
		featureCard: {
			width: 300,
			height: "100%"
		}

	} satisfies Record<string, CSSObject>);
